import { render, staticRenderFns } from "./OrderPurcharseAttentionQuote.vue?vue&type=template&id=dcca2416"
import script from "./OrderPurcharseAttentionQuote.vue?vue&type=script&lang=js"
export * from "./OrderPurcharseAttentionQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports